import CreateSubcontractingCompany from "./CreateSubcontractingCompany";
import DisplaySubcontractingCompany from "./DisplaySubcontractingCompany";
import { Route } from "react-router-dom";

const routes = {
  key: "SUBCONTRACTING_COMPANY",
  routes: ({ userScope }) => [
    <Route
      key={"subcontracting-company"}
      path={`${userScope}/subcontractor-company`}
    >
      <Route
        path=":slug"
        key={"subcontractor-company-display"}
        element={<DisplaySubcontractingCompany />}
      />
      <Route
        path="creation"
        key={"subcontractor-company-creation"}
        element={<CreateSubcontractingCompany />}
      />
    </Route>,
  ],
};
export default routes;
